export default "__VITE_ASSET__T70R9Ltg__"